import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function GoogleAuth() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");
    const saved = sessionStorage.getItem("g_oauth_state");

    const run = async () => {
      if (params.get("error")) { toast.error("Google sign-in was cancelled"); navigate("/login", { replace: true }); return; }
      if (!code) { navigate("/login", { replace: true }); return; }
      if (state && saved && state !== saved) { toast.error("Sign-in state mismatch — please try again"); navigate("/login", { replace: true }); return; }
      try {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google/exchange", { code, redirect_uri: redirectUri });
        setUser(data.user);
        sessionStorage.removeItem("g_oauth_state");
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Signed in with Google");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Google sign-in failed");
        navigate("/login", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="animate-spin text-brand" size={40} />
        <p className="text-slate-600 font-medium">Signing you in with Google…</p>
      </div>
    </div>
  );
}
